import InputSimplePhone from './InputSimplePhone';

export default InputSimplePhone;
